// extracted by mini-css-extract-plugin
export default {"countercontainer":"counters_countercontainer__zPy6a","f1":"counters_f1__Bs73A","f2":"counters_f2__fS2Ci","label":"counters_label__r6AI4","value":"counters_value__hLtGx"};